import * as React from 'react'
import { CastingType, castingI18nCastingType } from '../../../../services/models/castings.service'
import { StoreProps, castingStoreCanRenderCastingTypeInput } from '../../../../services/stores/casting.store'
import { I18nService } from '../../../../services/utils/i18n.service'
import ButtonGroupComponent from '../../../shared/button-group.component'

const i18nScoped = new I18nService(require('./casting-offered-service-casting-type.component.yml'))

export default function CastingOfferedServiceCastingTypeComponent ({ store, data, data: { offeredService, castingType, renderingMode } }: StoreProps) {
  const setCastingType = React.useCallback((castingType: CastingType) => {
    store.setCastingType(castingType)

    // widget: the castingType is asked with the offered_service
    if (renderingMode === 'widget') store.nextFocus({ from: 'offered-service' })

    // desktop & mobile: th ecastingType is asked at the begining of the second step
    else store.nextFocus({ from: 'end-of-step-1' })
  }, [renderingMode, store])

  const castingTypes = React.useMemo(
    () => (['casting_one_shot', 'casting_recurring'] as const).map(value => ({ value, text: castingI18nCastingType(value), disabled: !offeredService?.[value] })),
    [offeredService]
  )

  if (!castingStoreCanRenderCastingTypeInput(data)) return null
  return <>
    { renderingMode !== 'widget' && !castingType && <p className="castingStep-desc paragraph--desc"><strong>{ i18nScoped.t('please_select') }</strong></p> }
    <ButtonGroupComponent name="castingType" value={ castingType } onChange={ setCastingType } data={ castingTypes } itemByLine={ 2 } reemitOnClick />
  </>
}
